import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore'
import { db } from '@/firebase'
import { washPackages } from '@/config/washCatalog'

const DOC_PATH = ['settings', 'washCatalog']

function normalizePackages(packages) {
  const list = Array.isArray(packages) ? packages : []
  return list
    .filter((p) => p && p.id && p.name && Array.isArray(p.tiers))
    .map((p) => ({
      id: String(p.id),
      name: String(p.name),
      description: String(p.description || ''),
      tiers: p.tiers.map((t) => ({
        id: String(t.id),
        label: String(t.label),
        poa: Boolean(t.poa),
        price: Boolean(t.poa) ? 0 : Number(t.price || 0),
      })),
    }))
}

export const washCatalogService = {
  async get() {
    const ref = doc(db, ...DOC_PATH)
    const snap = await getDoc(ref)
    if (!snap.exists()) return null
    const data = snap.data()
    return {
      ...data,
      packages: normalizePackages(data.packages),
    }
  },

  async ensureInitialized() {
    const ref = doc(db, ...DOC_PATH)
    const snap = await getDoc(ref)
    if (snap.exists()) return snap.data()

    const payload = {
      packages: normalizePackages(washPackages),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      version: 1,
    }
    await setDoc(ref, payload)
    return payload
  },

  async updatePackages(packages) {
    const ref = doc(db, ...DOC_PATH)
    await updateDoc(ref, {
      packages: normalizePackages(packages),
      updatedAt: serverTimestamp(),
    })
  },
}

